import { MAPKEY } from "../actionTypes";

const mapKeyAction = (data) => {
    return {
        type: MAPKEY,
        data: data,
    };
};

export { mapKeyAction };